import React from 'react'
import { FilterSharpIcon, ArrowLeftIcon, ArrowRightIcon } from '../../Shared/SvgIcons'
import HyperTooltip from '../../Shared/HyperTooltip'
import Accordion from '../../Shared/Accordion'
import { IconDropDown } from '../../Shared/IconDropDown'
import { CollectionFilter } from '../../Shared/CollectionFilter'

import {
  SideBarContainer,
  ExpandHeader,
  FilterTitleWrapper,
  ReduceHeader,
  FilterContainer
} from './styles'

export const SideBar = (props) => {
  const { 
    isOpenSideMenu,
    setIsOpenSideMenu,
    filterValues,
    handleChangeFilterValues
  } = props

  const eventTypeList = [
    { id: 0, name: 'SALES', key: 'trade' },
    { id: 1, name: 'LISTINGS', key: 'sale' },
    { id: 2, name: 'BIDS', key: 'bid' },
    { id: 3, name: 'OFFERS', key: 'offer' }
  ]
  
  return (
    <SideBarContainer>
      {isOpenSideMenu ? (
        <ExpandHeader>
          <span onClick={() => setIsOpenSideMenu(false)}>
            <ArrowLeftIcon />
          </span>
          <FilterTitleWrapper>
            <FilterSharpIcon />
            <span>Filters</span>
          </FilterTitleWrapper>
        </ExpandHeader>
      ) : (
        <ReduceHeader  onClick={() => setIsOpenSideMenu(true)}>
          <HyperTooltip text="Filters">
            <ArrowRightIcon />
          </HyperTooltip>
        </ReduceHeader>
      )}
      <FilterContainer active={isOpenSideMenu}>
        <Accordion title='Event Type'>
          <div className="sort-div">
            <IconDropDown
              viewTypeList={eventTypeList}
              initialType={filterValues?.eventType}
              onChange={(val) => handleChangeFilterValues('eventType', val.key)}
              placeholder='Select a event type'
            />
          </div>
        </Accordion>
        <Accordion title='COLLECTIONS'>
          <CollectionFilter
            handleChangeFilterValues={handleChangeFilterValues}
            filterValues={filterValues}
          />
        </Accordion>
      </FilterContainer>
    </SideBarContainer>
  );
};